<script setup>
import PrimaryButton from '@/Components/Button/PrimaryButton.vue';
import Card from '@/Components/Card/Card.vue';
import TextInput from '@/Components/Input/TextInput.vue';
import { reactive } from 'vue';
import { router } from '@inertiajs/vue3';
import isValidIP from '@/Common/IsValidIp.js';
import isValidEmail from '@/Common/IsValidEmail.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  email: {
    type: String,
    default: '',
    required: false
  },
  ip: {
    type: String,
    default: '',
    required: false
  }
});

const state = reactive({
  emailAddress: props.email,
  ipAddress: props.ip,
  isLoading: false,
  errors: {}
});

const submit = () => {
  state.errors = {};
  if (!isValidEmail(state.emailAddress)) {
    state.errors['emailAddress'] = t(
      'spf_policy_test.partials.spf_policy_test_form.enter_valid_email'
    );
  }

  if (!isValidIP(state.ipAddress)) {
    state.errors['ipAddress'] = t(
      'spf_policy_test.partials.spf_policy_test_form.enter_valid_ip'
    );
  }

  if (Object.keys(state.errors).length > 0) {
    return false;
  }
  state.isLoading = true;
  router.get(
    route('spf-policy-test.show', [state.emailAddress, state.ipAddress])
  );
};
</script>

<template>
  <Card>
    <div class="mb-5">
      {{
        $t('spf_policy_test.partials.spf_policy_test_form.check_if_a_sender')
      }}
    </div>
    <form @submit.prevent="submit">
      <div class="flex flex-col gap-4 md:flex-row md:items-center">
        <TextInput
          v-model.trim="state.emailAddress"
          size="large"
          clearable
          required
          :label="
            $t('spf_policy_test.partials.spf_policy_test_form.email_address')
          "
          :description="
            state.errors?.emailAddress ??
            $t(
              'spf_policy_test.partials.spf_policy_test_form.email_description'
            )
          "
          class="md:mr-5"
          :variant="
            state.errors.hasOwnProperty('emailAddress') ? 'danger' : 'default'
          "
        />
        <TextInput
          v-model.trim="state.ipAddress"
          size="large"
          clearable
          required
          :label="
            $t('spf_policy_test.partials.spf_policy_test_form.ip_address')
          "
          :description="
            state.errors?.ipAddress ??
            $t('spf_policy_test.partials.spf_policy_test_form.ip_description')
          "
          :variant="
            state.errors.hasOwnProperty('ipAddress') ? 'danger' : 'default'
          "
        />
        <div class="flex">
          <PrimaryButton
            size="large"
            :is-loading="state.isLoading"
            class="mt-2"
          >
            {{
              $t(
                'spf_policy_test.partials.spf_policy_test_form.run_policy_spf_test'
              )
            }}
          </PrimaryButton>
        </div>
      </div>
    </form>
  </Card>
</template>
